<div class="alert alert-primary" *ngIf="item && item.state == 'rented'">
	Objektet är uthyrt.
</div>
<div class="alert alert-secondary state-new" *ngIf="item && item.state == 'new'">
	<span>Objektet är nytt och ej markerat som ledigt.</span>
	<span class="error" *ngIf="error">{{ error }}</span>
	<button
		*ngIf="users.hasRole('item_user')"
		class="btn btn-primary btn-sm"
		[disabled]="working"
		(click)="setAvailable()"
	>
		Markera som ledigt
	</button>
</div>
<div class="alert alert-dark" *ngIf="item && item.state == 'withdrawn'">
	Objektet är återtaget.
</div>
